export default __webpack_public_path__ + "static/media/shazam.39437824.svg";